'use strict';

const { Component } = require('phy');

const { publish, subscribe } = require('../../support/event-observer');
const { getOfferRedemptionData } = require('../../support/redemption-helper');
const storage = require('../../support/storage-helper');
const { waitOnEvent, affiliateEvents } = require('../../support/event-helper');

function getConfig() {
  const { isTouch, csrfToken } = window.Groupon.Utils.getConfigFromDom();

  return { isTouch, csrfToken };
}

function closeHandler() {
  publish('@redemption', null);

  window.history.replaceState(
    {},
    '',
    window.location.href.replace(window.location.search, '')
  );
}

function getAdjustedDataForExpiredOffers(data) {
  const copyOfData = { ...data };

  if (!copyOfData.offerTitle) {
    copyOfData.type = 'ALERT';
  }

  return copyOfData;
}

function importModal(isTouch) {
  const imports = [import('../../support/modal')];

  if (isTouch) {
    imports.push(import('@grpn/coupons-components/view'));
  } else {
    imports.push(import('@grpn/coupons-components/modal'));
  }

  return Promise.all(imports);
}

class RedemptionProvider extends Component {
  constructor(props, ...rest) {
    super(props, ...rest);

    this.state = {
      redemptionData: null,
    };

    this.isTouch;
    this.setRedemptionData = this.setRedemptionData.bind(this);
  }

  componentDidMount() {
    affiliateEvents();
    subscribe('@redemption', this.setRedemptionData);

    const { isTouch, csrfToken } = getConfig();

    this.isTouch = isTouch;
    this.csrfToken = csrfToken;

    this.setRedemption();
  }

  getChildContext() {
    const { directRedemption, referralSource } = this.props;

    return {
      directRedemption,
      referralSource,
    };
  }

  openModal() {
    if (!this.state.redemptionData) {
      return;
    }

    importModal(this.isTouch).then(([{ presenter, clickHandler }]) => {
      const modalData = this.getModalData();
      const data = presenter(modalData, this.context);

      const config = {
        dialogShown: true,
        showBackButton: true,
        showFeedback: true,
        showEmail: true,
        data,
        type: modalData.type,
        clickHandler,
        clickHandlerParams: modalData,
        closeHandler,
      };

      if (window.Coupons.ShowModal) {
        return window.Coupons.ShowModal(config);
      }

      return window.Coupons.ShowView(config);
    });
  }

  setRedemptionData(data) {
    this.setState(
      {
        redemptionData: data,
      },
      this.openModal
    );

    if (data) {
      publish('OFFER_DATA', {
        offerId: data.offerId,
        referralSource: this.props.referralSource,
        merchantId:
          data.merchantId || (data.merchant && data.merchant.merchantId),
      });
    }

    this.toggleModalStyling(!!data);
  }

  getModalData() {
    const { routes, referralSource, directRedemption } = this.props;

    return {
      ...getAdjustedDataForExpiredOffers(this.state.redemptionData),
      referralSource,
      directRedemption,
      csrfToken: this.csrfToken,
      routes,
      closeHandler,
      publish,
      i18n: this.context.grapefruit,
    };
  }

  setRedemption() {
    const { directRedemption } = this.props;
    const couponRedeemed = storage.getItem('couponRedeemed');

    if (couponRedeemed) {
      storage.setItem('couponRedeemed', false);

      waitOnEvent({
        doneCheck: () => {
          const data = storage.getItem('@redemption') || {};
          return !!(data.offerCode && data.merchantMedia);
        },
        callback: () => {
          this.setRedemptionData(storage.getItem('@redemption'));
          window.localStorage.removeItem('@redemption');
        },
        fallback: () => {
          this.setRedemptionData({
            type: 'ALERT',
            alertMessage: 'GeneralError',
          });
          window.localStorage.removeItem('@redemption');
        },
      });
    } else if (directRedemption) {
      this.setRedemptionData(getOfferRedemptionData(directRedemption));
    } else {
      publish('MERCHANT_DATA', {
        merchantId: this.props.merchantId,
        referralSource: this.props.referralSource,
      });
    }
  }

  toggleModalStyling(modalOpen) {
    if (modalOpen) {
      document.body.style.top = `-${window.scrollY}px`;
      document.body.classList.add('lock-scroll');
    } else {
      document.body.classList.remove('lock-scroll');
      const scrollY = document.body.style.top;
      document.body.style.top = '';
      window.scrollTo(0, parseInt(scrollY || '0') * -1);
    }
  }
}

module.exports = RedemptionProvider;
